import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { DeviceService } from 'src/app/services/device.service';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-broker',
  templateUrl: './broker.component.html',
  styleUrls: ['./broker.component.scss'],
  providers: [DeviceService]
})
export class BrokerComponent implements OnInit, AfterViewInit {
  @ViewChild('videoDesktop') videoDesktop: ElementRef<HTMLVideoElement>;
  @ViewChild('videoMobile') videoMobile: ElementRef<HTMLVideoElement>;

  isOS = true;
  lang: string;

  constructor(
    private localeService: LocaleService,
    private deviceService: DeviceService,
  ) {}

  ngOnInit() {
    this.isOS = this.deviceService.isOS();
    this.lang = this.localeService.currentLocale;
  }

  ngAfterViewInit() {
    this.playVideo(this.videoDesktop?.nativeElement);
    this.playVideo(this.videoMobile?.nativeElement);
  }

  playVideo(video: HTMLVideoElement) {
    if (video) {
      video.muted = true;
      video.play();
      video.oncanplaythrough = function() {
        video.muted = true;
        video.play();
      };
    }
  }
}
